import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IApplicationState } from '../../Store';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';
import { History } from 'history';
import { IUserState } from '../../Store/User/Types';
import { IStatsState } from '../../Store/Statistics/Types';
import { LineChart } from './LineChart';
import { IDashboardState, randomImages } from '../../Store/Dashboard/Types';
import { DrawSelect } from '../Sidebar/DrawSelect';
import { ISearchState } from '../../Store/Search/Types';
import { getTheme } from '../../Themes';
import SearchIcon from '@material-ui/icons/Search';
import { Export } from '../Dashboard/Export';
import { getExportStatsEvolutionPdf, getExportStatsEvolutionXls } from '../../Store/Export/Actions';

const theme = getTheme();

const styles = (theme:any) => MD.createStyles({
  inputClasses:{
    fontSize:'small',
    width: '50%',
    border: '1px gray'
  },
  formControl: {
    width: '100%',
    marginTop:'5px'
  },
  stepNumber: {
    padding: '10px', color: theme.palette.primary.main, fontSize: 25
  },
  stepsContainer: {
    padding: 20,
    marginLeft: 180, marginTop: 180, width: '75%', 
    backgroundColor: theme.palette.background.paper
  },
  label: {
      fontFamily: 'Lato',
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '16px',
      letterSpacing: '0px',
      textAlign: 'left',
      marginTop: -9,
      marginLeft: 17,
      color: theme.palette.text.primary
  }
});

interface IPropsFromState {
    i18n: I18N;
    localeInfos: ILocaleInfos;
    history: History;
    user: IUserState;
    stats: IStatsState;
    search: ISearchState;
    dashboard: IDashboardState;
}

interface IPropsFromDispatch {
  getExportStatsEvolutionPdf: typeof getExportStatsEvolutionPdf;
  getExportStatsEvolutionXls: typeof getExportStatsEvolutionXls;
}

interface IState {
}

type AllProps =
    MD.WithTheme &
MD.WithStyles<typeof styles> &
    IPropsFromState &
    IPropsFromDispatch;

export class StatisticsEvolutionContentComponent extends React.Component<AllProps, IState> {
    
    public constructor(props: AllProps) {
        super(props);

        this.state = {
        }
    }

    static getDerivedStateFromProps(props: AllProps, state: IState) {
      return null
    }
    public componentDidMount(){
    }

    public componentDidUpdate(){
      
    }

    public getSnapshotBeforeUpdate(prevProps: AllProps, prevState:any){
      return null;
    }
    
    private buildMediasLogos(media_ids: number[]) {
      return (
        <div
          style={{
            display: "inline-flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-evenly",
            alignItems: "baseline",
          }}
        >
          {media_ids.map((id) => {
            return <img key={id} height={34} src={randomImages[id]} alt={""} />;
          })}
        </div>
      );
    }
    private buildTitle() {
            
      return(
          <div style={{display: 'block'}}>
            { this.props.stats.statsEvolutionFilters !== null && 
            <div style={{display: 'inline-flex'}}>
              { this.buildMediasLogos(this.props.stats.statsEvolutionFilters.media_ids) }
              <span style={{padding: '5px', fontWeight: 500}}>
                  {
                    this.props.stats.statsEvolutionFilters.medias_str !== undefined &&
                    this.props.stats.statsEvolutionFilters.medias_str.filter(x => x !== '').join(', ')}
              </span>
            </div>
            }
            <div style={{textTransform: 'capitalize'}}>
              <span style={{color: theme.palette.primary.main}}>
                  {this.props.stats.statsEvolutionFilters?.year}
              </span>
              <div style={{color: theme.palette.primary.main}}>
                  {
                    this.props.stats.statsEvolutionFilters?.programs_str !== undefined &&
                    this.props.stats.statsEvolutionFilters?.programs_str.filter(x => x !== '').join(', ')}
              </div>
          </div>
        </div>
      )
    }

    private buildExport() {
      const { stats } = this.props;
      let filters:any = 
        stats.statsEvolutionFilters !== null ? {
          year: stats.statsEvolutionFilters.year,
          media_ids: stats.statsEvolutionFilters.media_ids,
          program_type_ids: stats.statsEvolutionFilters.program_type_ids,
          political_group_ids: stats.statsEvolutionFilters.political_group_ids
        } : {}
      return (
        <div style={{position: 'absolute', right: '15px', display: 'inline-flex', paddingTop: 10}}>
            <Export exportAction={this.props.getExportStatsEvolutionPdf} 
            filters={filters} exportType = 'pdf' />
            <Export exportAction={this.props.getExportStatsEvolutionXls}
            filters={filters} exportType = 'xls' />
        </div>
    )}
    private drawLineChart(data: any, chartId: string, category: string, value: string, year:number) {
      const { history } = this.props;
        return(
          <div style={{ width: '100%'}}>
            <div style={{display: 'inline-flex'}}>
              { this.buildTitle() }
              { this.buildExport() }
            </div>
            <MD.Divider style={{marginTop: '40px', width: '98%'}} />
            <LineChart 
            data={data} 
            category={category}
            value={value}
            history={history} 
            chartId={chartId}  
            year={year}
            />
          </div>
        )
    }
    
    private buildSelectYear() {
      const { classes, dashboard } = this.props;
      let endDate = new Date();
      if (dashboard.dateCloture !== null) {
        endDate = dashboard.dateCloture
      }

      const startYear = 2012
      let yearsRange:number[] = []
      for (let i = startYear; i < endDate.getFullYear() + 1; i++)  {
          yearsRange.push(i)
      }
      return(
        <MD.FormControl className={this.props.classes.formControl} style={{padding: '10px'}}>
          <MD.InputLabel className={classes.label} shrink={false}>
                {endDate.getFullYear()}
          </MD.InputLabel>
          <MD.Select
              open={false}
              disabled
              labelId="tear-label"
              id="demo-simple-select-outlined"
              value={endDate.getFullYear()}
              onChange={(ev) => {}}
              label="Age"
              variant='filled'
              input={<MD.OutlinedInput className={classes.inputClasses} />}
              renderValue={(value:any) => {
                  return (
                  null )
              }}
              MenuProps={{
                  getContentAnchorEl: null,
                  anchorOrigin: {
                      vertical: "top",
                      horizontal: "left",
                  }
              }}
              >
                  { 
                    yearsRange.map(x => {
                        return <MD.MenuItem key={x} value={x}>{x}</MD.MenuItem>
                    }) 
                  }
              </MD.Select>
        </MD.FormControl>
      )
    }

    private buildSteps() {
      const { i18n, classes } = this.props;
      return(
        <>
          
          <MD.Grid className={classes.stepsContainer}>
            
            <div style={{display: 'inline-flex', width: '100%'}}>
              <SearchIcon style={{fontSize: '50px', color: theme.palette.secondary.main}}/>
              <span style={{padding: 10, width: '50%'}}>
                { i18n._('Steps to follow') }..
              </span>
            </div>
            <div style={{display:'inline-flex', width: '100%'}}>
              <div style={{display:'inline-flex', width:'50%'}}>
                <span className={classes.stepNumber}>
                  1.
                </span>
                <div style={{width: '100%'}}>
                  {this.buildSelectYear()}
                </div>
              </div>
              <div style={{display:'inline-flex', width: '50%'}}>
                <span className={classes.stepNumber}>
                  2.
                </span>
                <div style={{width: '70%'}}>
                  <DrawSelect 
                    i18n={i18n} 
                    title= {i18n._('Medias')}
                    list={this.props.user.medias} 
                    listID={this.props.user.allMediasID}
                    listStr={this.props.user.allMediasSTR}
                    isAllSelected={true}
                    allListIDs={this.props.user.allMediasID}
                    allListStr={this.props.user.allMediasSTR}
                    saveChanges={() => null}
                    multiple={true}
                    open={false}
                  /> 
                </div>
              </div>
                
            </div>
            <div style={{display:'inline-flex', width: '100%'}}>
              <div style={{display:'inline-flex', width:'50%'}}>
                <span className={classes.stepNumber}>
                  3.
                </span>
                <div style={{width: '70%'}}>
                  <DrawSelect 
                    i18n={i18n} 
                    title= {i18n._('Program types')}
                    list={this.props.search.programTypes} 
                    listID={this.props.search.allProgramTypesID}
                    listStr={this.props.search.allProgramTypesSTR}
                    isAllSelected={true}
                    allListIDs={this.props.search.allProgramTypesID}
                    allListStr={this.props.search.allProgramTypesSTR}
                    saveChanges={() => null}
                    multiple={true}
                    open={false}
                  /> 
                </div>
              </div>
              <div style={{display:'inline-flex', width: '50%'}}>
                <span className={classes.stepNumber}>
                  4.
                </span>
                <div style={{width: '70%'}}>
                  <DrawSelect 
                    i18n={i18n} 
                    title= {i18n._('Poltical groups')}
                    list={this.props.search.politicalGroup} 
                    listID={this.props.search.allPoliticalGroupID}
                    listStr={this.props.search.allPoliticalGroupSTR}
                    isAllSelected={true}
                    allListIDs={this.props.search.allPoliticalGroupID}
                    allListStr={this.props.search.allPoliticalGroupSTR}
                    saveChanges={() => null}
                    multiple={true}
                    open={false}
                  /> 
                </div>
              </div>
            </div>
          </MD.Grid>
        </>
      )
    }

    public render(): React.ReactNode {
      const { i18n, stats } = this.props;
        return (
          <>   
            {
              stats.dataGroup === null && !stats.isLoading && stats.statsEvolutionFilters === null &&
              this.buildSteps()
            }         
            { (stats.isLoading) &&
               <span>
                  {i18n._('Loading')}...
               </span>
            }
            { stats.dataEvolutionPerMonth !== null && stats.dataEvolutionPerMonth.length === 0 && !stats.isLoading &&
            <span>
              {i18n._('No results')}
            </span>
            }
            { 
              stats.dataEvolutionPerMonth !== null && stats.dataEvolutionPerMonth.length > 0 &&
              ! stats.isLoading && stats.statsEvolutionFilters !== undefined && stats.statsEvolutionFilters !== null &&
              this.drawLineChart(stats.dataEvolutionPerMonth, "chartLineGroup", "month", "percent", stats.statsEvolutionFilters.year)
            }
        </>
      )
    }
  }

    

const mapStateToProps = ({i18n, user, stats, search, dashboard} : IApplicationState) => {
  return {
    i18n: i18n.i18n,
    localeInfos: i18n.localeInfos,
    user: user,
    stats,
    search,
    dashboard
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getExportStatsEvolutionPdf: (filters: any) => dispatch(getExportStatsEvolutionPdf(filters)),
  getExportStatsEvolutionXls: (filters: any) => dispatch(getExportStatsEvolutionXls(filters)),

});

export const StatisticsEvolutionContent = 
    connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(StatisticsEvolutionContentComponent)));
